export default "__VITE_ASSET__QgUDrHVr__"